export default "__VITE_ASSET__sC0_Th2Y__"